module.exports = __webpack_public_path__ + "./fonts/White_Rose_Noto_regular.ttf";